'use client'

import dynamic from 'next/dynamic'
import { Suspense } from 'react'

import { ChainLoader } from '../../../../components/chain-loader'
import { CarrierOnboardingProvider } from '../_context/carrier-onboarding-context'

const CarrierOnboardingPageContent = dynamic(() =>
  import('./carrier-onboarding-page-content').then((mod) => ({ default: mod.CarrierOnboardingPageContent }))
)

export const CarrierOnboardingPageWrapper = () => {
  return (
    <CarrierOnboardingProvider>
      <Suspense fallback={<ChainLoader />}>
        <CarrierOnboardingPageContent />
      </Suspense>
    </CarrierOnboardingProvider>
  )
}
